export const OC_PRODUCT_CATALOG_DOWNLOAD_LOADER = {
  desktop: `
<div class="cui-grid cui-container -spacing--top-64 -spacing--bottom-80">
  <div class="cui-row">
    <div class="cui-col cui-col-md-10 cui-col-xs-12 col-offset-md-1">
      <div class="cui-skeleton-heading -size--large -spacing--bottom-40 -resolution--desktop">
        <div class="cui-skeleton__item cui-skeleton-input__label -spacing--bottom-40" style="width: max(20px, 20%);"></div>
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
            <div class="cui-skeleton__item -spacing--bottom-16 cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item -spacing--bottom-24 cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item -spacing--bottom-24" style="width: 100%; height: 400px;"></div>
      </div>
      <div class="cui-skeleton__item cui-skeleton-input__label -spacing--bottom-40" style="width: max(20px, 40%);"></div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 108px; height: 48px;"></div>
      </div>
    </div>
  </div>
</div>
`
};
